var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16772 0.685924L1.10728 13.024C0.599668 13.9112 1.26234 15 2.30994 15H16.4313C17.4789 15 18.1415 13.9112 17.6339 13.024L10.573 0.685924C10.0495 -0.228641 8.69129 -0.228641 8.16772 0.685924ZM9.37088 3.75C9.88865 3.74994 10.3084 4.16963 10.3085 4.68739L10.3086 9.37456L8.43364 9.37494L8.43349 4.68761C8.43343 4.16984 8.85311 3.75006 9.37088 3.75ZM10.3086 9.37456C10.3086 9.89233 9.88888 10.3125 9.37111 10.3125C8.85334 10.3125 8.43362 9.8927 8.43364 9.37494L10.3086 9.37456ZM10.3081 12.1875C10.3081 12.7053 9.88837 13.125 9.37061 13.125C8.85284 13.125 8.43311 12.7053 8.43311 12.1875C8.43311 11.6697 8.85284 11.25 9.37061 11.25C9.88837 11.25 10.3081 11.6697 10.3081 12.1875Z",
    fill: "#FC4D0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.2d3682ef7299322f783ae30c7f27b458.svg";
export { ForwardRef as ReactComponent };